module.exports = __webpack_public_path__ + "media/crosses/close-4c7df5e0.svg";